var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AltchaGate',{on:{"verified":_vm.enterApplication}})
}
var staticRenderFns = []

export { render, staticRenderFns }